export default function () {

  const widgetName = 'swiperWidgetMainFeature';
  const widgetOpts = swiperWidgetMainFeatureOpts;
  let autoplay = {
    delay: 6000,
  }

  const swiperContainers = `
    <div class="swiper-container">
        <div class="swiper-wrapper">
        </div>
    </div>
   
   `;

  // Slide Template
  function buildSlideTemplate(slide) {
    let buyUrl = slide.PurchaseURL
    let moreUtl = slide.URL
    let buyButton;
    let moreButton;

    if (moreUtl == null) {
      moreButton = `<a href="${slide.URL}" class="button" style="display: none;">More ></a>`
    } else {
      moreButton = `<a href="${slide.URL}" class="button">More ></a>`
    }

    if (buyUrl == null) {
      buyButton = `<a class="button  moreButtonLarger" style="display: none;">Buy Now!</a>`
    } else {
      buyButton = `<a href="${slide.PurchaseURL}" class="button">Buy Now!</a>`
    }


    const template = `
      <div class="swiper-slide">
          <div class="swiper-image-container swiper-lazy" data-background="${slide.ImageWithPath}" aria-label="${slide.ImageAlternateText}">
            <div class="main-events-buttons">
              ${buyButton}  
              ${moreButton}        
            </div>
            <div class="swiper-pagination"></div>
            <div class="swiper-lazy-preloader"></div>
          </div>
        <div class="main-events-container">
          <div class="main-event-middle-section">
            <div class="main-events-text">
              <h2 class="feature-title">${slide.Title}</h2>
              <span class="feature-description">${slide.Description}</span>    
              <div class="main-events-buttons mobile-buttons">
                ${buyButton}
                ${moreButton}    
              </div>
            </div>
          </div>
        </div>
      </div>`;
    return template;
  }

  // Swiper Initialization
  function initSwiper(widgetData) {
    function autoPlayCondition() {
      if (widgetData.length > 1) {
        return autoplay
      } else {
        autoplay = false
        return autoplay
      }
    }

    const swiperWidgetWrapper = $(`#${widgetName} .swiper-wrapper`);
    widgetData.forEach(function (slide, i) {
      swiperWidgetWrapper.append(buildSlideTemplate(slide));
    });

    const swiperWidget = new Swiper(`#${widgetName} .swiper-container`, {
      speed: 600,
      autoplay: autoPlayCondition(),
      spaceBetween: 0,
      pagination: {
        el: `#${widgetName} .swiper-pagination`,
        type: 'bullets',
        clickable: true,
      },
      navigation: false,
      centeredSlides: false,
      preloadImages: false,
      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 1
      },
      a11y: true,
      autoHeight: true,
      loop: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
    });
  }

  // Fetch data and initialize widget
  saffire.utils.getWidgetData(widgetOpts).then(function (response) {
    if (response.Slides.length > 0) {
      $(`#${widgetName}`).html(swiperContainers);
      initSwiper(response.Slides);
    } else {
      // console.log(response);
      console.log('Error: No Data for swiperWidget');
    }
  });
}
